export const versionWithoutMinor = (version: string) => {
  const minorIndex = version.lastIndexOf(".");
  return version.substring(0, minorIndex);
};
